import { Grid } from "@mui/material";
import Utility from "../../../common/utilities";
import { Chip } from "../../Chip/Chip";
import React from "react";
import UserDetails from "../../UserDetails/UserDetails";
import { IHeaderTemplateBaseProp } from "../../../Model/UI";

import "./Header5.scss";

export interface IHeader5Prop extends IHeaderTemplateBaseProp {
  label1: string;
  label2: string;
  chip1: string;
}
/*
UI placement:

    label1          
    label2
    userDetails     chip1
                           
 */

export function Header5(props: IHeader5Prop) {
  function getHeaderUI() {   
    return (
      <div
        data-testid="header-5"
        className={Utility.getClassNamesFromProps("header-5", props.className)}
      >
        {/* 1st row */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="row-1"
        >
          <div className="dot"></div>
          <p className="label-1">{props.label1}</p>
          <div className="spacer"></div>
        </Grid>

        {/* 2nd row */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="row-2"
        >
          <p className="label-2">{props.label2}</p>
        </Grid>

        {/* 3rd row */}
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className="row-3"
        >
          <UserDetails
            userId={props.userDetails.userId}
            userCardName={props.userDetails.userCardName}
            userOrganization={props.userDetails.userOrganization}
            // className="user-details"
          ></UserDetails>
          <div className="spacer"></div>
          <div className="col-1">
            <Chip className="chip-1" label={props.chip1}></Chip>
          </div>
        </Grid>
      </div>
    );
  }

  return getHeaderUI();
}
